<template>
  <div>
    <PButton
      :variant="bVariant"
      :icon="icon"
      :iColor="iColor"
      :iType="iType"
      @click="showSidebarFunction"
    >
      {{ textButton }}
    </PButton>
    <transition name="slide-fade">
      <div v-if="showSidebar" class="container_PSidebar" :style="widthComp">
        <div class="titleContainer_PSidebar">
          <div class="title_PSidebar">
            <PIcon :icon="icon" :type="iType" :color="iColor" :size="iSize" v-if="icon"></PIcon>
            <div>
              <slot name="title">{{ title }}</slot>
            </div>
          </div>

          <div class="close_PSidebar">
            <span @click="close">
              <PIcon icon="close" type="material" class="closeIcon_PSidebar"></PIcon>
            </span>
          </div>
        </div>
        <div class="content_PSidebar">
          <slot></slot>
        </div>
      </div>
    </transition>
    <div v-if="showSidebar" class="divLoadingTodoOpacity" @click="close"></div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export class PSidebar extends Vue {
  @Prop({ required: true }) value!: boolean;
  @Watch("value", { immediate: true })
  onChangeValue(): void {
    this.showSidebar = this.value;
  }
  @Prop({ required: false, default: "40%" }) width!: string;
  @Prop({ required: false, default: "" }) title!: string;
  @Prop({ required: false }) icon!: string;
  @Prop({ required: false, default: "text" }) iType!: string;
  @Prop({ required: false, default: "#6f6f6f" }) iColor!: string;
  @Prop({ required: false, default: "25" }) iSize!: number;
  @Prop({ required: true }) textButton!: string;
  @Prop({ required: false, default: "secondary" }) bVariant!: string;

  showSidebar = false;

  get widthComp(): string {
    if (this.width != "") {
      return "width:" + this.width + ";";
    } else {
      return "";
    }
  }
  showSidebarFunction(): void {
    this.showSidebar = true;
    this.$emit("input", this.showSidebar);
  }
  close(): void {
    this.showSidebar = false;
    this.$emit("input", this.showSidebar);
  }
}
export default PSidebar;
</script>
<style lang="scss" scoped>
.container_PSidebar {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  box-shadow: 0 0 5px 0 #939393;
  background-color: #fff;
  z-index: 6;
  overflow-y: auto;

  @media (max-width: 768px) {
    width: 100% !important;
  }
}
.titleContainer_PSidebar {
  display: flex;
  justify-content: space-between;
  padding: 20px 26px 21px 44px;
  background-color: #fff;
}
.title_PSidebar {
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4c4c4c;
  display: flex;
  align-items: center;
}
.close_PSidebar {
  font-size: 1rem;
  color: #939393;
  margin-bottom: -10px;
}
.closeIcon_PSidebar {
  cursor: pointer;
}
.content_PSidebar {
  padding: 20px;
}
.divLoadingTodoOpacity {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  opacity: 0.8;
  background-color: #fff;
  z-index: 5;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.5s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(100%);
}
</style>
